<template>
  <div>
    <base-nav
      v-model="showMenu"
      type="white"
      :transparent="false"
      menu-classes="justify-content-end"
      class="navbar-horizontal navbar-main"
      expand="lg"
    >
      <div slot="brand" class="navbar-wrapper">
        <b-navbar-brand to="/">
          <img src="/img/brand/brand.svg" />
        </b-navbar-brand>
      </div>

      <template>
        <div class="navbar-collapse-header">
          <b-row>
            <b-col cols="6" class="collapse-brand">
              <router-link to="/">
                <img src="/img/brand/brand.svg" />
              </router-link>
            </b-col>
            <b-col cols="6" class="collapse-close">
              <button
                type="button"
                class="navbar-toggler"
                @click="showMenu = false"
              >
                <span></span>
                <span></span>
              </button>
            </b-col>
          </b-row>
        </div>

        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="logout" v-if="user">
            <span class="nav-link-inner--text">Logout</span>
          </b-nav-item>
          <b-nav-item to="https://adminhero.co" v-if="!user">
            <span class="nav-link-inner--text">Home</span>
          </b-nav-item>
          <b-nav-item to="/login" v-if="!user">
            <span class="nav-link-inner--text">Login</span>
          </b-nav-item>
          <b-nav-item to="/register" v-if="!user">
            <span class="nav-link-inner--text">Register</span>
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav v-if="!user">
          <hr class="d-lg-none" />
          <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
          <li class="nav-item d-none d-lg-block ml-lg-4">
            <a href="/register" class="btn btn-primary btn-icon">
              <span class="btn-inner--icon">
                <i class="fas fa-bolt mr-2"></i>
              </span>
              <span class="nav-link-inner--text">Sign up now</span>
            </a>
          </li>
        </b-navbar-nav>
      </template>
    </base-nav>

    <div class="main-content">
      <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
        <router-view></router-view>
      </zoom-center-transition>
    </div>

    <footer class="py-5" id="footer-main">
      <b-container>
        <b-row align-v="center" class="justify-content-xl-between">
          <b-col xl="6">
            <div class="copyright text-center text-xl-left text-muted">
              © {{ year }}
              <a
                href="https://melior.im"
                class="font-weight-bold ml-1"
                target="_blank"
                >Melior Enterprises Limited</a
              >
            </div>
          </b-col>
          <b-col xl="6" class="col-xl-6">
            <b-nav
              class="nav-footer justify-content-center justify-content-xl-end"
            >
              <b-nav-item href="https://adminhero.co">Home</b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>
<script>
import { BaseNav } from "@/components";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    BaseNav,
    ZoomCenterTransition,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page",
    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    },
    user() {
      return this.$auth.user();
    },
  },
  methods: {
    logout() {
      this.$auth
        .logout()
        .then(() => {
          // clear any local storage
          this.$ls.clear();
          // clear from store
          this.$store.commit("SET_ACCOUNT", null);
          this.$store.commit("SET_MEMBERSHIP", null);
        })
        .catch((err) => {
          console.error("Error after logout(): ", err);
        });
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-default");
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-default");
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    },
  },
  beforeDestroy() {
    this.removeBackgroundColor();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function () {
        this.updateBackground();
      },
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}
</style>
